<template>
  <div class="row" style="margin-top: 15px">
    <fieldset>
      <legend style="width: 440px">Quantidade de atendimento por profissional</legend>
      <div class="row">
        <div class="title-group">Período</div>
        <div class="group-itens">
          <div class="item-filter">
            <a-date-picker show-time type="date" placeholder="Data Início" style="width: 100%" format="DD/MM/yyyy" v-model:value="form.dtIni" />
          </div>
          <div class="item-filter">
            <a-date-picker show-time type="date" placeholder="Data Fim" style="width: 100%" format="DD/MM/yyyy" v-model:value="form.dtFim" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="title-group">Profissional</div>
        <div class="group-itens">
          <div class="item-filter">
            <select class="form-select" v-model="form.pessoaFisicaNome">
              <option v-for="item in this.lstProfissional" :key="item.nome" :value="item.nome">
                {{ item.nome }}
              </option>
            </select>
          </div>
          <div class="item-filter">
            <label class="form-check-label" for="todos">Todos </label>
            <input class="form-check-input" type="checkbox" id="todos" v-model="form.todos" />
          </div>
        </div>
      </div>
      <div class="row" style="margin-top: 15px">
        <div style="width: 180px">
          <a-tooltip title="Pesquisar" placement="top">
            <div class="input-group-prepend icon" style="text-align: center">
              <span class="input-group-text bg-white" @click="searchData">
                <i class="fa fa-search" style="margin: 0px 10px"></i>
                <span>Pesquisar</span>
              </span>
            </div>
          </a-tooltip>
        </div>
        <div class="col"></div>
        <div style="display: flex; flex-direction: row; width: 600px">
          <div style="width: 150px">
            <a-tooltip title="Imprimir" placement="top" v-if="dadosTabela.length > 0" @click="imprimirPDF">
              <div class="input-group-prepend icon" style="text-align: center">
                <span class="input-group-text bg-white">
                  <i class="fa-solid fa-print" style="margin: 0px 10px"></i>
                  <span>Imprimir</span>
                </span>
              </div>
            </a-tooltip>
          </div>
          <div style="width: 200px">
            <a-tooltip title="Imprimir" placement="top" v-if="dadosTabela.length > 0" @click="imprimirPDFAgrupadoPorMesAno">
              <div class="input-group-prepend icon" style="text-align: center">
                <span class="input-group-text bg-white">
                  <i class="fa-solid fa-print" style="margin: 0px 10px"></i>
                  <span>Imprimir Detalhado</span>
                </span>
              </div>
            </a-tooltip>
          </div>
          <div style="width: 170px">
            <a-tooltip title="Imprimir" placement="top" v-if="dadosTabela.length > 0" @click="encaminharEmail">
              <div class="input-group-prepend icon" style="text-align: center">
                <span class="input-group-text bg-white">
                  <i class="fa-solid fa-share" style="margin: 0px 10px"></i>
                  <span>Encaminhar</span>
                </span>
              </div>
            </a-tooltip>
          </div>
        </div>
        <div class="row" style="margin-top: 10px">
          <a-table :dataSource="dadosTabela" :columns="columns"> </a-table>
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script>
import { gerarRelatorioHtml, gerarRelatorioPdf, gerarRelatorioPdfAtendimentoAgrupadoMesAno } from '@/components/service/gerarRelatorio';
import { abrirImpressaoPorBlob, encaminharEmailTo } from '@/utils/servicos-utils';
import { gerarRelatorioProfissionalQtdeAtendimento, gerarRelatorioProfissionalQtdeAtendimentoAgrupadoPorMesAno, getListaProfissionaisResumida } from '@/components/service/profissionalService';

export default {
  name: 'AtendimentoProfRelatorio',
  data() {
    return {
      dadosTabela: [],
      dadosTabelaAgrupadaPorMesAno: [],
      lstProfissional: [],
      form: {
        dtIni: undefined,
        dtFim: undefined,
        todos: true,
        pessoaFisicaNome: undefined,
        pessoaFisicaCpf: undefined,
      },
      columns: [
        {
          title: 'Nome do Profissional',
          dataIndex: 'descricao',
          key: 'descricao',
        },
        {
          title: 'Quantidade',
          dataIndex: 'quantidade',
          key: 'quantidade',
        },
      ],
    };
  },

  methods: {
    async searchData() {
      await gerarRelatorioProfissionalQtdeAtendimento(this.form)
        .then((r) => {
          this.dadosTabela = r.data;
          this.atendimentosAgrupadoPorPeriodo();
        })
        .catch((e) => {
          console.log(e);
        });
    },
    async atendimentosAgrupadoPorPeriodo() {
      await gerarRelatorioProfissionalQtdeAtendimentoAgrupadoPorMesAno(this.form)
        .then((r) => {
          this.dadosTabelaAgrupadaPorMesAno = r.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    async imprimirPDF() {
      if (this.dadosTabela.length > 0) {
        await gerarRelatorioPdf({
          listaDadosDocumento: this.dadosTabela,
          nomeDocumentoHtml: 'relatorio-profissional-qtde-por-atendimento.html',
          filtro: this.form,
        }).then((r) => {
          abrirImpressaoPorBlob(r.data);
        });
      }
    },
    async imprimirPDFAgrupadoPorMesAno() {
      if (this.dadosTabela.length > 0) {
        await gerarRelatorioPdfAtendimentoAgrupadoMesAno({
          listaDadosDocumento: this.dadosTabelaAgrupadaPorMesAno,
          nomeDocumentoHtml: 'relatorio-profissional-qtde-por-atendimento-agrupado-mes-ano.html',
          filtro: this.form,
        }).then((r) => {
          abrirImpressaoPorBlob(r.data);
        });
      }
    },
    async encaminharEmail() {
      if (this.dadosTabela.length > 0) {
        await gerarRelatorioHtml({
          listaDadosDocumento: this.dadosTabela,
          nomeDocumentoHtml: 'relatorio-convenio-paciente.html',
        }).then((r) => {
          encaminharEmailTo('Relatório de Paciente por Convenio', r.data);
        });
      }
    },
    async carregarProfissionais() {
      await getListaProfissionaisResumida()
        .then((r) => {
          this.lstProfissional = r.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
  created() {
    this.carregarProfissionais();
  },
};
</script>

<style scoped>
.title-group {
  margin-bottom: 5px;
  font-size: 16px;
  font-weight: bold;
}

.group-itens {
  display: flex;
  flex-direction: row;
}

.form-check-label {
  font-size: 14px;
  margin: 0px 10px;
}

.input-group-prepend {
  cursor: pointer;
}

.input-group-text {
  padding: 0.375rem 26px 4px 11px;
  height: 38px;
}

.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  background: #2bec96 !important;
}

.icon {
  cursor: pointer;
}

.item-filter {
  margin: 10px;
}

.item-filter.form-check-input {
  margin: 10px;
}
</style>
